import { useMutation } from "react-query";
import { updateAlarmType } from "../../../../../actions/Utilities/AlarmType";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateAlarmType,
  alarmTypeReFetching,
} from "../atoms/atoms";
import { IAlarmType } from "../types";
import { toast } from "components/toastNotification";

const useEditAlarmType = () => {
  // return useMutation(updateAlarmType);
  
  const setActionEditState = useSetRecoilState(editStateAlarmType);
  const [isReFetching, setIsReFetching] = useRecoilState(
    alarmTypeReFetching
  );

  const { mutate } = useMutation(
    (newData: IAlarmType) => updateAlarmType(newData),
    {
      onSuccess: (res) => {

        if (typeof res == "object") {
          toast.fire(
            "Updating Alarm Type failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Alarm Type Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Alarm Type Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Alarm Type failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Alarm Type failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Alarm Type failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire(
                "Updating Alarm Type failed",
                `${res}`,
                "error"
              );
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Alarm Type failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditAlarmType;
